export default {
  omwServer: {
    url: 'https://v4j8sd3j9d.execute-api.eu-west-2.amazonaws.com/dev/onmyway',
    apiKey: 'cb94d0fe-23e8-4481-ab11-226841255daf',
  },
  here: {
    apiKey: '-UNLLnFloRUKYlvfF6qBVs4gG_pvAwSqKQn98ehWGrg',
    mapHeightMobile: '40vh',
    mapHeightDesktop: '65vh',
    mapWidthMobile: '93vw',
    mapWidthDesktop: '47vw',
    mapWidth: '100%',
    imperial: true,
    showZoom: true,
    majorVersion: 'v3',
    minorVersion: '3.1.30.3',
    centreLat: 53.361463,
    centreLng: -1.67194,
    defaultZoom: 14,
  },
  marketing: {
    enabled: true,
    customer: 'reliancehomecomfort',
    retrievalUrl:
      'https://v4j8sd3j9d.execute-api.eu-west-2.amazonaws.com/dev/marketing/published',
    recordClickUrl:
      'https://v4j8sd3j9d.execute-api.eu-west-2.amazonaws.com/dev/marketing/clicked',
    fieldName: 'category',
    demo: true,
    demoCustomer: 'reliancehomecomfort',
    defaultClickUrl: 'https://reliancehomecomfort.com/heat-pumps/'
  },
  feedback: {
    enabled: true,
    url: 'https://g1n6a29e8b.execute-api.eu-west-2.amazonaws.com/ifs-demo/feedback',
  },
  intercom: {
    enabled: true,
    appId: 'rx6jmmc5',
    onlineDays: {
      1: {
        showTime: '00:00',
        hideTime: '23:59',
      },
      2: {
        showTime: '00:00',
        hideTime: '23:59',
      },
      3: {
        showTime: '00:00',
        hideTime: '23:59',
      },
      4: {
        showTime: '00:00',
        hideTime: '23:59',
      },
      5: {
        showTime: '00:00',
        hideTime: '23:59',
      },
      6: {
        showTime: '00:00',
        hideTime: '23:59',
      },
    },
    // onlineBuckets: []
  },
  trustpilot: {
    enabled: false,
  },
  logos: [],
  display: {
    separatorEnabled: false,
    dateFormat: 'MMM dd, yyyy',
    timeFormat: 'h:mma',
    eta: {
      useCalculatedEta: true,
      bufferBeforeMins: 10,
      bufferAfterMins: 10,
    },
    defaultEngineerName: 'Your technician',
    defaultEngineerPhoto: 'default-engineer.png',
    customerWebsite: 'https://www.ifs.com',
    notification: {
      show: true,
    },
    licencePlateEnabled: false,
    showLicencePlate: false,
    licencePlateCountry: 'xx',
    engineerIcon: {
      opacity: 1,
      width: 50,
      height: 50,
      anchorX: 40,
      anchorY: 35,
      svg: `<svg id="Layer_1" version="1.1" viewBox="0 0 512.00003 512" width="512" height="512" xml:space="preserve" xmlns="http://www.w3.org/2000/svg" xmlns:cc="http://creativecommons.org/ns#" xmlns:dc="http://purl.org/dc/elements/1.1/" xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#" xmlns:svg="http://www.w3.org/2000/svg"><defs id="defs7"/><g id="g2998" transform="matrix(1.0256411,0,0,1.0256411,75.075284,86.74009)"><g id="g551" transform="translate(-6192.9984,-1450.7716)"><path d="m 6603.4,1614.5 c 0,-4.1 -2.5,-7.7 -6.2,-9.3 l -69.1,-28.2 c -2.2,-0.9 -4.1,-2.6 -5.2,-4.8 l -28.9,-57.7 c -4.1,-8.2 -12.4,-13.3 -21.6,-13.3 H 6404.8 6215 c -5.5,0 -10,4.5 -10,10 v 146.5 h 199.9 v -3.7 h 127.2 v -9.9 h 71.2 v -29.6 z m -178,-40.2 v -52.6 h 47.1 c 1.4,0 2.7,0.8 3.3,2 l 25.3,50.6 h -75.7 z" id="path553" style="fill:#146589"/><g id="g555"><path d="M 6569.9,1633 H 6496.7 6314.3 6205 v 47 c 0,5.1 4.1,9.1 9.1,9.1 h 124.2 134.2 121.7 c 5.1,0 9.1,-4.1 9.1,-9.1 v -47 h -10.3 -23.1 z" id="path557" style="fill:#146589"/></g><g id="g559"><g id="g561"><path d="m 6265.3,1671.4 c 9.8,0 17.7,7.9 17.7,17.7 0,9.8 -7.9,17.7 -17.7,17.7 -9.8,0 -17.7,-7.9 -17.7,-17.7 0,-9.7 7.9,-17.7 17.7,-17.7 m 0,-23.6 c -22.8,0 -41.3,18.5 -41.3,41.3 0,22.8 18.5,41.3 41.3,41.3 22.8,0 41.3,-18.5 41.3,-41.3 0,-22.8 -18.5,-41.3 -41.3,-41.3 l 0,0 z" id="path563" style="fill:#404041"/><path d="m 6265.3,1671.4 c -9.8,0 -17.7,7.9 -17.7,17.7 0,9.8 7.9,17.7 17.7,17.7 9.8,0 17.7,-7.9 17.7,-17.7 0,-9.7 -8,-17.7 -17.7,-17.7 z" id="path565" style="fill:#ffffff"/></g><g id="g567"><path d="m 6543.1,1671.4 c 9.8,0 17.7,7.9 17.7,17.7 0,9.8 -7.9,17.7 -17.7,17.7 -9.8,0 -17.7,-7.9 -17.7,-17.7 0,-9.7 8,-17.7 17.7,-17.7 m 0,-23.6 c -22.8,0 -41.3,18.5 -41.3,41.3 0,22.8 18.5,41.3 41.3,41.3 22.8,0 41.3,-18.5 41.3,-41.3 0,-22.8 -18.5,-41.3 -41.3,-41.3 l 0,0 z" id="path569" style="fill:#404041"/><path d="m 6543.1,1671.4 c -9.8,0 -17.7,7.9 -17.7,17.7 0,9.8 7.9,17.7 17.7,17.7 9.8,0 17.7,-7.9 17.7,-17.7 0,-9.7 -7.9,-17.7 -17.7,-17.7 z" id="path571" style="fill:#ffffff"/></g></g><g id="g573"><path d="m 6266.7,1537.8 h -121.3 c -5.5,0 -10,-4.5 -10,-10 l 0,0 c 0,-5.5 4.5,-10 10,-10 h 121.3 c 5.5,0 10,4.5 10,10 l 0,0 c 0,5.5 -4.5,10 -10,10 z" id="path575" style="fill:#189dcc"/></g><g id="g577"><path d="m 6232.6,1589.1 h -53.2 c -5.5,0 -10,-4.5 -10,-10 l 0,0 c 0,-5.5 4.5,-10 10,-10 h 53.2 c 5.5,0 10,4.5 10,10 l 0,0 c 0,5.5 -4.5,10 -10,10 z" id="path579" style="fill:#189dcc"/></g><g id="g581"><path d="m 6211.8,1641.1 h -11.5 c -5.5,0 -10,-4.5 -10,-10 l 0,0 c 0,-5.5 4.5,-10 10,-10 h 11.5 c 5.5,0 10,4.5 10,10 l 0,0 c 0,5.5 -4.5,10 -10,10 z" id="path583" style="fill:#189dcc"/></g></g></g></svg>`,
    },
    activityIcon: {
      opacity: 1,
      width: 30,
      height: 30,
      anchorX: 0,
      anchorY: 30,
      svg: `<svg width="30px" height="30px" id="Layer_1" style="enable-background:new 0 0 64 64;" version="1.1" viewBox="0 0 64 64" xml:space="preserve" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><style type="text/css">
      .st0{fill:#A99260;}
      .st1{fill:#FBFBFB;}
      .st2{fill:#8F4139;}
      .st3{fill:#F3F4F3;}
      .st4{fill:#C9AC68;}
      .st5{opacity:0.25;enable-background:new    ;}
      .st6{fill:#B1C0C9;}
      .st7{fill:#58595B;}
      .st8{fill:#808285;}
      .st9{fill:#F1F2F2;}
      .st10{fill:#A97C50;}
      .st11{fill:#8B5E3C;}
      .st12{opacity:0.25;fill:#231F20;enable-background:new    ;}
      .st13{fill:#5F3D1D;}
      .st14{fill:#302719;}
      .st15{fill:#EED09D;}
      .st16{fill:#FBB040;}
      .st17{fill:#754C29;}
      .st18{opacity:0.2;fill:#231F20;enable-background:new    ;}
      .st19{fill:#5B7954;}
      .st20{fill:#939598;}
      .st21{fill:#D8D13E;}
      .st22{fill:#53697A;}
      .st23{fill:#847D26;}
      .st24{fill:#C4BA3D;}
      .st25{fill:#1C1C1C;}
      .st26{fill:#4B5022;}
      .st27{fill:#302D26;}
      .st28{fill:#602F2D;}
      .st29{fill:#F0EAD6;}
      .st30{fill:#C6CDC7;}
      .st31{fill:#4D4D62;}
      .st32{fill:#543D17;}
      .st33{fill:#8C8A80;}
      .st34{fill:#737977;}
      .st35{fill:#7B7C7F;}
      .st36{fill:#5F6252;}
      .st37{fill:#ABADB0;}
      .st38{fill:#AC9578;}
      .st39{fill:#899F9A;}
      .st40{fill:#7C9A7B;}
      .st41{fill:#C7C8CA;}
      .st42{fill:#443F35;}
      .st43{fill:#71535C;}
      .st44{fill:#72322F;}
      .st45{fill:#F6E5C3;}
      .st46{fill:#D3AF71;}
      .st47{fill:#B98F5C;}
      .st48{fill:#D3D1D3;}
      .st49{fill:#7A7B7E;}
      .st50{fill:#596A63;}
      .st51{fill:#D7B262;}
      .st52{fill:#E9E9EA;}
      .st53{fill:#55382F;}
      .st54{fill:#684A3C;}
      .st55{fill:#A3A5A8;}
      .st56{fill:#8F9083;}
      .st57{fill:#B0AB8E;}
      .st58{fill:#7895A4;}
      .st59{fill:#999889;}
      .st60{fill:#82BFBF;}
      .st61{fill:#A5DCE0;}
      .st62{fill:#7E706D;}
      .st63{fill:#E7E2D8;}
      .st64{fill:#467082;}
      .st65{fill:#7CB0A9;}
      .st66{fill:#70726C;}
      .st67{fill:#DCCD9B;}
      .st68{fill:#414042;}
      .st69{fill:#809EAD;}
      .st70{opacity:0.1;fill:#231F20;enable-background:new    ;}
      .st71{fill:#B4B6AB;}
      .st72{fill:#6D894C;}
      .st73{fill:#765E3D;}
      .st74{fill:#9A8154;}
      .st75{fill:#CEB98D;}
      .st76{fill:#443423;}
      .st77{fill:#D1D3D4;}
      .st78{fill:#8B6649;}
      .st79{fill:#E6E3B7;}
      .st80{opacity:0.2;}
      .st81{fill:#775640;}
      .st82{fill:#7A8367;}
      .st83{fill:#4678AD;}
      .st84{fill:#004E7F;}
      .st85{fill:#27689E;}
      .st86{fill:#E6E7E8;}
      .st87{fill:#6B4E38;}
      .st88{fill:#A29A8F;}
      .st89{fill:#541E17;}
      .st90{fill:#48726D;}
      .st91{fill:#231F20;}
      .st92{fill:#7A352F;}
      .st93{fill:#A84C45;}
      .st94{fill:#BB882C;}
      .st95{opacity:0.3;fill:#1B443F;enable-background:new    ;}
      .st96{opacity:0.4;fill:#231F20;enable-background:new    ;}
      .st97{opacity:0.5;fill:#1B443F;enable-background:new    ;}
      .st98{fill:#9FB3B6;}
      .st99{fill:#547B80;}
      .st100{fill:#B0A67A;}
      .st101{fill:#9C8F57;}
      .st102{fill:#B08874;}
      .st103{fill:#C9B09A;}
      .st104{fill:#9C7761;}
      .st105{fill:#B6B6AB;}
      .st106{fill:#A3BFD9;}
      .st107{fill:#667A95;}
      .st108{fill:#B8BDB4;}
      .st109{fill:#AA91AB;}
      .st110{fill:#675890;}
      .st111{fill:#46408A;}
      .st112{fill:#959A8F;}
      .st113{fill:none;stroke:#A29A8F;stroke-width:1.0023135;stroke-miterlimit:10;}
      .st114{fill:#867F71;}
      .st115{fill:#D0D2C7;}
      .st116{fill:#726C61;}
      .st117{fill:#4D4D4F;}
      .st118{fill:#C1BBB3;}
      .st119{fill:#F2F1E8;}
      .st120{opacity:0.2;enable-background:new    ;}
    </style><g><path class="st15" d="M56.5742455,33.9552803L31.9128036,10.5686302L7.4374232,33.9446564   c-0.2110562,0.2014771-0.4383159,0.3741531-0.6747231,0.5253983v27.5515137C6.7627001,63.1142273,7.6398544,64,8.721879,64   H55.278492c1.0820236,0,1.9591789-0.8857727,1.9591789-1.9784317V34.4727707   C57.0051498,34.3240013,56.7823753,34.1526527,56.5742455,33.9552803z"/><path class="st2" d="M26.3253212,37.5053711H14.9144773c-0.9026585,0-1.6344099,0.7389374-1.6344099,1.6504784v20.5919228   h14.6796646V39.1558495C27.9597321,38.2443085,27.2279797,37.5053711,26.3253212,37.5053711z"/><ellipse class="st16" cx="16.2996464" cy="48.8078346" rx="1.8942375" ry="1.8599548"/><rect class="st6" height="14.7015467" width="13.8721714" x="36.7685776" y="38.0000534"/><path class="st11" d="M51.1305428,37.0108376H36.3104324c-0.2707291,0-0.4897957,0.2212219-0.4897957,0.4946098V53.196209   c0,0.2733879,0.2190666,0.494606,0.4897957,0.494606h14.8201103c0.2707291,0,0.4897957-0.2212181,0.4897957-0.494606V37.5054474   C51.6203384,37.2320595,51.4012718,37.0108376,51.1305428,37.0108376z M50.6407509,44.8559761h-6.4304695v-6.8559227h6.4304695   V44.8559761z M43.2306938,38.0000534v6.8559227h-6.4304695v-6.8559227H43.2306938z M36.8002243,45.845192h6.4304695v6.8564072   h-6.4304695V45.845192z M44.2102814,52.7015991V45.845192h6.4304695v6.8564072H44.2102814z"/><path class="st17" d="M59.5909805,35.1618538c-1.0819473,0-2.1658096-0.3994522-3.0167351-1.2065735L31.9128036,10.5686302   L7.4374232,33.9446564c-1.7697654,1.6895866-4.5592985,1.60989-6.231966-0.1753349   c-1.6726676-1.7861938-1.5951805-4.6036243,0.1736283-6.2932129L28.8731117,1.2174478   c1.6946697-1.6190684,4.3454895-1.6238985,6.0468597-0.0106263l27.6896553,26.2586613   c1.7745514,1.682827,1.8620834,4.5002575,0.1956291,6.2922459C61.9375954,34.6904297,60.7657204,35.1618538,59.5909805,35.1618538z   "/><path class="st18" d="M56.5742455,33.9552803L31.9128036,10.5686302l-2.5985661,2.4818554l27.9234333,26.4801846v-5.0578995   C57.0051498,34.3240013,56.7823753,34.1526527,56.5742455,33.9552803z"/><path class="st19" d="M51.9763031,62.2775078c-0.1399078-0.62146,0.9015617-1.6580734,0.6337051-2.2187347   c-0.2722206-0.5697784-1.7267151-0.3918457-2.1136131-0.8812599c-0.3889313-0.4918938,0.1048698-1.8840637-0.3821716-2.2768784   c-0.4847755-0.3909378-1.7188263,0.4031372-2.2831802,0.1281204c-0.5553207-0.270607-0.7077866-1.7425385-1.3233185-1.8838806   c-0.5961571-0.1368752-1.364212,1.1195107-2.0013885,1.1195107c-0.6370544,0-1.4050484-1.2563858-2.001091-1.1195717   c-0.6153526,0.1412811-0.7676964,1.6131516-1.3228989,1.8836403c-0.5642319,0.2748375-1.7981071-0.5194206-2.2828178-0.1286621   c-0.4871025,0.3927498,0.0065155,1.7849846-0.382473,2.2768135c-0.3871346,0.4894753-1.8416328,0.3114853-2.1139717,0.881382   c-0.2679787,0.5607834,0.7733154,1.5976982,0.6334076,2.2192764C36.9009476,62.8792229,35.5137138,63.3566246,35.5137138,64   h17.9852448C53.4989586,63.3566818,52.1117859,62.8794022,51.9763031,62.2775078z"/><path class="st20" d="M29.7830639,59.7477722H11.4567347c-0.5415945,0-0.9806471,0.4433784-0.9806471,0.9902725V64h20.2876244   v-3.2619553C30.7637119,60.1911507,30.3246593,59.7477722,29.7830639,59.7477722z"/></g></svg>`,
    },
    disableContactUs: true,
    contactCentreNo: '',
    loadingLogo: 'logo.png',
    companyLogo: 'logo.png',
    headerHeight: '4em',
    imageHeight: '2em',
    footerText: `
      <div style="white-space:nowrap">&#xa9 IFS {year} - Appointment Assistant</span>
        <span style="white-space:nowrap">
      <br/></div>`,
    showDeliveryForFuture: false,
    companyLogoPosition: {
      padding: '0.25em 0 0 0.25em',
    },    
  },
  reschedule: {
    rebookEnabled: true,
    cancelEnabled: true,
    url: 'https://v4j8sd3j9d.execute-api.eu-west-2.amazonaws.com/dev',
    daysToRetrieve: 7,
    hideRagRed: false,
    rebookCutoff: {
      numberOfDaysInFuture: -1,
      cutoffTime: '00:00',
    },
    cancelCutoff: {
      numberOfDaysInFuture: -1,
      cutoffTime: '00:00',
    },
    expiryMins: 5,
    allowEarlierThanOriginal: true,
    dateFormat: 'MMM dd, yyyy',
    timeFormat: 'h:mma',
    showTimezoneLabel: true,
    allowContactCentreRebook: true,
    enableDatepicker: true,
    blockRebookOnApptDay: true,
  },
  notes: {
    enabled: true,
    url: 'https://v4j8sd3j9d.execute-api.eu-west-2.amazonaws.com/dev/onmyway/note',
    dateTimeFormat: 'MMM dd, yyyy, h:mma',
    maxNoteLength: 300,
  },
  photos: {
    enabled: true,
    maxAllowed: 5,
    maxSize: 1024,
    dateTimeFormat: 'MMM dd, yyyy, h:mma',
    url: 'https://v4j8sd3j9d.execute-api.eu-west-2.amazonaws.com/dev/onmyway/photo',
  },  
  calendarImport: {
    enabled: true,
    alarms: ['-PT24H', '-PT1H'],
    organizer: 'organizer',
    filePrefix: 'prefix',
  },
};
